export const SET_PIN_ACTION = 'SET_PIN_ACTION';
export const SET_PIN_SUCCESS_ACTION = 'SET_PIN_SUCCESS_ACTION';
export const SET_PIN_FAILURE_ACTION = 'SET_PIN_FAILURE_ACTION';
